module.exports = __webpack_public_path__ + "static/img/apokPortafolio.ad7d01c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/apokPortafolio.jpg
// module id = 437
// module chunks = 1